import { SearchFiltersQueryParams } from 'components/FilterMenu/SearchFilter/SearchFilter';
import { FILTER_MENU_ACTION, FilterMenuActionKey } from 'store/action-types/filter-menu.action-types';

import { Brand } from '../../types/brand.types';

export const setFilterMenuData = (target: FilterMenuActionKey, data: unknown) => ({
  type: FILTER_MENU_ACTION[target].INIT_SET,
  payload: data,
});

export const parseQueryParamsForFilterSelectionAction = (
  target: FilterMenuActionKey,
  selectedFilterData: SearchFiltersQueryParams,
  brandPageBrand?: Brand,
) => ({
  type: FILTER_MENU_ACTION[target].SELECTION_PARSED_FROM_URL_PARAMS,
  payload: selectedFilterData,
  brandPageBrand,
});
